export default __webpack_public_path__ + "static/media/warning-icon.c2285bd2.svg";